// extracted by mini-css-extract-plugin
export var listItem = "messenger-tree-module--list-item--fSeeX";
export var textWrapper = "messenger-tree-module--text-wrapper--VR-iZ";